import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GroupClassDetailsModel, GroupClassParticipantsModel } from '@bayclubs/group-classes-employee-api';
@Component({
    selector: 'app-group-classes-bookings',
    templateUrl: './group-classes-bookings.component.html',
    styleUrls: ['./group-classes-bookings.component.scss'],
    standalone: false
})
export class GroupClassesBookingsComponent implements OnInit {
    @Input()
    public model: GroupClassDetailsModel;
    @Output()
    public attendanceLoaded: EventEmitter<GroupClassParticipantsModel> = new EventEmitter();
    public attendance: GroupClassParticipantsModel;

    constructor() {}

    ngOnInit() {}

    public onAttendanceLoaded(attendance: GroupClassParticipantsModel) {
        this.attendance = attendance;
        this.attendanceLoaded.emit(attendance);
    }

    public get showWaitList(): boolean {
        return this.model.isWaitListAllowed;
    }
}
